export default class FilterForm {
  constructor() {
    this.form = document.querySelector('[data-filter-form]');
    if (!this.form) return;
    this.fieldWrapper = this.form.querySelectorAll('[data-form-field-wrapper]');
    this.formButton = document.querySelector('[data-filter-form-button]');

    this.handleSelectChange();
  }

  handleSelectChange() {
    this.fieldWrapper.forEach((wrapper, i) => {
      const select = wrapper.querySelector('select');
      if (select) {
        select.addEventListener('change', () => {
          if (select.value === '') {
            for (
              let index = i + 1;
              index < this.fieldWrapper.length;
              index += 1
            ) {
              this.fieldWrapper[index].querySelector('select').value = '';
              this.fieldWrapper[index].classList.add('d-none');
              this.formButton.classList.add('d-none');
            }
            return;
          }

          if (select.value !== '') {
            if (i + 1 === this.fieldWrapper.length) {
              this.formButton.classList.remove('d-none');
            } else this.fieldWrapper[i + 1].classList.remove('d-none');
          }
        });
      }
    });
  }
}
